import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'campaigntrack/artwork/FETCH_REQUEST'
const FETCH_SUCCESS = 'campaigntrack/artwork/FETCH_SUCCESS'
const FETCH_FAILURE = 'campaigntrack/artwork/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadArtworks(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/artworks', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ARTWORK_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createArtworkOrder(artwork, artworkPages, options){
  const config = {
    method: 'POST',
    data: JSON.stringify(artworkPages),
  }

  return () => {
    const promise = api(`/artworks/${artwork.id}/artwork-order`, options, config)
      .then(({ data }) => ({ success: true, data }))
      .catch((data) => {
        const errors = handleError(data)
        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
